// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Sm1y","options":"AnswerScale_options__3LJMK","selected":"AnswerScale_selected__2w9nZ"};